// extracted by mini-css-extract-plugin
export default {"banner-wrapper":"Banner_banner-wrapper__00zkL","banner-image":"Banner_banner-image__wTUnQ","start-button":"Banner_start-button__1T4L5","close-button":"Banner_close-button__uxgoc"};